import axios from "axios";
import { GENERAL_URL_API } from "../../../urls";

export async function fetchSuperInstitutos() {
  const { data } = await axios.get(
    `${GENERAL_URL_API}/superInstituto/verSuperInstitutos`,
    {
      withCredentials: true,
    }
  );

  return data?.data ?? [];
} 